import { useEffect } from 'react'
import {
  App,
  Button,
  Card,
  Col,
  Row,
  Skeleton,
  Space,
  Spin,
  Statistic,
} from 'antd'
import { initialQuery } from '../models/helper'
import PageTitle from '../components/PageTitle'
import { Profile } from '../components/profile/Profile'
import { useAppDispatch, useAppSelector } from '../store/hooks'
import { getProfiles, selectProfiles } from '../store/ProfileReducer'
import { useAuth } from '../contexts/Auth'
import { Answer } from '../components/answer/Answer'
import i18n from '../i18n/setupLocalization'
import LocalizationKeys from '../i18n/LocalizationKeys'
import Gleap from 'gleap'
import { useSearchParams } from 'react-router-dom'
import {
  getGleapTourAlreadyShown,
  setGleapTourAlreadyShown,
} from '../helpers/UserLocalStorageHelper'

const ProfilesPage = () => {
  const { message } = App.useApp()

  const dispatch = useAppDispatch()
  const profiles = useAppSelector(selectProfiles())
  const { currentUser } = useAuth()

  const { query, isLoading } = useAppSelector((state) => state.profile)
  const [searchParams, setSearchParams] = useSearchParams()

  const fetchProfiles = () => {
    dispatch(getProfiles(initialQuery))
  }
  useEffect(() => {
    fetchProfiles()
  }, [dispatch])
  /**
   * This page may have a utm_source=stripe_payment_success
   * Stripe Success Message display and Gleap start tour if never shown
   */

  useEffect(() => {
    const searchUTMSource = searchParams.get('utm_source')
    if (searchUTMSource == 'stripe_payment_success') {
      message.success(
        i18n.t(LocalizationKeys.Page.ProfilesPage.SubscriptionActivated)
      )
      if (getGleapTourAlreadyShown() == undefined) {
        Gleap.startProductTour('67769937529e3b08c302240c')
        setGleapTourAlreadyShown('67769937529e3b08c302240c')
      }
    }
  }, [searchParams])

  return (
    <Row gutter={[16, 16]}>
      <Col span={24} style={{ marginTop: 20 }}>
        {currentUser && (
          <PageTitle
            type="sympa"
            title={i18n.t(LocalizationKeys.Page.ProfilesPage.Title, {
              name: currentUser.name,
            })}
            // toolbar={
            //   <Space>
            //     <Card
            //       className="big-border-purple"
            //       styles={{ body: { paddingTop: 10, paddingBottom: 10 } }}
            //     >
            //       <Answer.Analytics />
            //     </Card>
            //   </Space>
            // }
          />
        )}
      </Col>
      {isLoading && (
        <>
          <Col lg={6} md={8} sm={12} xs={24}>
            <Skeleton.Node active={true} className="card-skeleton" />
          </Col>
          <Col lg={6} md={8} sm={12} xs={24}>
            <Skeleton.Node active={true} className="card-skeleton" />
          </Col>
          <Col lg={6} md={8} sm={12} xs={24}>
            <Skeleton.Node active={true} className="card-skeleton" />
          </Col>
        </>
      )}
      {!isLoading && (
        <>
          {profiles.map((profil) => (
            <Col key={profil.id} lg={6} md={8} sm={12} xs={24}>
              <Profile.Card model={profil} />
            </Col>
          ))}
          <Col lg={6} md={8} sm={12} xs={24}>
            <Profile.AddModal onCreated={fetchProfiles} />
          </Col>
        </>
      )}
    </Row>
  )
}

export default ProfilesPage
